import { render, staticRenderFns } from "./CourseByUserStudy.vue?vue&type=template&id=405c7b23&"
import script from "./CourseByUserStudy.vue?vue&type=script&lang=js&"
export * from "./CourseByUserStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports